<template>
    <div class="ranking item-list" :class="{'inline': !config.vertical}">
        <draggable :list="items" @change="onChange">
            <div v-for="(item, index) in items" :key="index" class="item tw-group/rank tw-mb-2">
                <div class="choice" :style="{
                    ...inputStyles,
                    borderColor: inputStyles.color,
                    backgroundColor: convertHexToRGBA(inputStyles.color, 10)
                }">
                    <span class="rank tw-inline-block tw-text-center"
                          :style="{
                        color: inputStyles.color,
                        borderColor: inputStyles.color
                      }"
                    >
                    {{ index + 1 }}
                </span>
                    <survey-page-editable :target="item" :editable="editable" placeholder="Choice" @changed="onEditableChange($event,index)" />
                </div>

                <span v-if="editable" class="remove tw-hidden group-hover/rank:tw-inline-block" @click="deleteChoice(index)"></span>
            </div>
        </draggable>
        <div v-if="editable" class="add-choice" :style="{color: inputStyles.color}" @click="addChoice">Add Choice</div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import SurveyPageEditable from "@/pages/surveys/SurveyPageEditable.vue";

export default {
    name: 'QuestionRanking',
    components: {SurveyPageEditable, draggable},
    props: {
        value: {
            type: Array,
            default: undefined
        },
        inputStyles: {
            type: Object,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            items: [],
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(items) {
                this.items = items || this.config.options;
                this.onChange();
            }
        },
        'config.options'() {
            this.resetOptions();
        },
    },
    methods: {
        onEditableChange(item,index) {
            this.items[index] = item;
            this.onChange();
        },
        onChange() {
            if (!this.readonly) this.$emit('answer', {value: this.items, valid: true});
            if (this.editable) this.$emit('config', {options: this.items});
        },
        addChoice() {
            if (!this.editable) return;
            this.items.push('');
            this.$emit('config', {options: this.items});
        },
        deleteChoice(index) {
            this.items.splice(index,1);
            this.$emit('config', {options: this.items});
        },
        resetOptions() {
            this.items = this.config.options;
            if (!this.items) this.items = [];
            console.log(this.items);
        }
    },
    mounted() {
        //this.resetOptions();
    }
}
</script>
<script setup>
</script>